import { Employer } from "@entities/employer";
import { useClientRest } from "@shared/hooks";
import { transformQueryParamsWithoutLocale } from "@shared/utils";
import { useQuery } from "@tanstack/react-query";

export function useUserEmployers({ limit = 100 }: { limit?: number } = {}) {
  const { request } = useClientRest();

  const query = useQuery<{ data: Employer[] }>({
    queryKey: ["user-employers", limit],
    queryFn: () =>
      request({
        url: transformQueryParamsWithoutLocale("/karirhub/onboarding/v2/employers/me", { limit }),
        method: "GET",
        options: { cache: "no-store" },
      }),
  });

  const refetch = () => {
    query.refetch();
  };

  return {
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    employers: query.data?.data || [],
    query,
    refetch,
  };
}
